var _defineProperty = require("/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var validator = require('validator');
var joi = require('joi');
var _require = require('./shared-constants'),
  VALID = _require.VALID,
  INVALID = _require.INVALID;
var CONSTANTS = {
  VALID: VALID,
  INVALID: INVALID
};
var parse = function parse(email) {
  var result = {
    valid: INVALID,
    email: null,
    formatted: null,
    error: {
      type: 'genericError',
      message: "Invalid email: ".concat(email)
    }
  };
  if (!email || !String(email || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid email';
    return result;
  }
  if (!validator.isEmail(email.trim())) {
    return result;
  }
  var joiRes = joi.string().email({
    tlds: {
      allow: false
    }
  }).validate(email.trim());
  if (joiRes.error) {
    return result;
  }
  var normalizeOptions = {
    all_lowercase: true,
    gmail_remove_subaddress: true,
    outlookdotcom_remove_subaddress: true,
    yahoo_remove_subaddress: true,
    icloud_remove_subaddress: true
  };
  var normalizedEmail = validator.normalizeEmail(email.trim(), normalizeOptions);
  return {
    valid: VALID,
    email: email,
    formatted: normalizedEmail,
    error: {
      type: null,
      message: null
    }
  };
};
module.exports = _objectSpread({
  parse: parse
}, CONSTANTS);